import behaviourConstants from "@/constants/behaviourManagementConstants.js"
import behaviourCoreValueConstants from "@/constants/behaviourCoreValueConstants.js"
import behaviourPointHistoryConstants from "@/constants/behaviourPointHistoryConstants.js"
import behaviourCustomizedThemeConstants from "@/constants/behaviourCustomizedThemeConstants.js"
import behaviourPositiveBehaviourConstants from "@/constants/behaviourPositiveBehaviourConstants.js"

/**
 * @param {string | null | undefined} role
 * @returns {boolean}
 */
export function isBehaviourAdminRole(role) {
  return behaviourConstants.BEHAVIOUR_ADMIN_ROLES.includes(role)
}

/**
 * @param {string | null | undefined} role
 * @returns {string}
 */
export function resolveCoreValuesListApiPath(role) {
  return isBehaviourAdminRole(role)
    ? behaviourCoreValueConstants.CORE_VALUES_API_PATH
    : behaviourCoreValueConstants.CORE_VALUES_STAFF_API_PATH
}

/**
 * @param {string | null | undefined} role
 * @returns {string}
 */
export function resolvePositiveBehavioursListApiPath(role) {
  return isBehaviourAdminRole(role)
    ? behaviourPositiveBehaviourConstants.POSITIVE_BEHAVIOURS_API_PATH
    : behaviourPositiveBehaviourConstants.POSITIVE_BEHAVIOURS_STAFF_API_PATH
}

/**
 * @param {string | null | undefined} role
 * @returns {string}
 */
export function resolvePointHistoryTransactionsApiPath(role) {
  if (role === "student") {
    return behaviourPointHistoryConstants.STUDENT_TRANSACTIONS_API_PATH
  }
  return behaviourPointHistoryConstants.TRANSACTIONS_API_PATH
}

/**
 * @param {string | null | undefined} role
 * @returns {string}
 */
export function resolveCustomizedThemeSettingsApiPath(role) {
  return isBehaviourAdminRole(role)
    ? behaviourCustomizedThemeConstants.CUSTOMIZED_THEME_API_PATH
    : behaviourCustomizedThemeConstants.CUSTOMIZED_THEME_STAFF_API_PATH
}
